import './FlexRow.scss';

import React from 'react';

interface Props {
  children: any;
  noMargin?: boolean;
  right?: boolean;
  left?: boolean;
  noBottomMargin?: boolean;
  noTopMargin?: boolean;
}

export default (props: Props) => (
  <div
    className={`FlexRow ${props.noMargin ? 'no-margin' : ''} ${props.right ? 'right' : ''} ${
      props.left ? 'left' : ''
    }  ${props.noBottomMargin ? 'no-bottom-margin' : ''} 
    ${props.noTopMargin ? 'no-top-margin' : ''}`}
  >
    {props.children}
  </div>
);
